import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UptimeRobotService} from '../../services/uptime-robot-service';
import {UptimeRobotMonitor, UptimeRobotMonitorStatus} from '../../models/uptime-robot.model';
import {WhmcsService} from '../../services/whmcs-service';
import {WhmcsStats} from '../../models/whmcs-stats.model';
import {StripeService} from '../../services/stripe-service';
import {StripePayout} from '../../models/stripe.model';
import {WccService} from '../../services/wcc-service';
import {Website} from '../../models/website.model';
import {TwilioService} from '../../services/twilio-service';
import {SmsService} from '../../services/sms-service';
import {SMSBalance} from '../../models/sms.model';

@Component({
  selector: 'app-streamup-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  loadingMonitors$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  loadingWebsitePromotions$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  loadingWhmcsStats$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  loadingStripePayouts$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  loadingTwilioAccountBalance$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  loadingMessageBirdAccountBalance$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  hasMonitors$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  hasStripePayouts$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  hasWebsitePromotions$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  monitors$: BehaviorSubject<UptimeRobotMonitor[]> = new BehaviorSubject<UptimeRobotMonitor[]>([]);
  websitePromotions$: BehaviorSubject<Website[]> = new BehaviorSubject<Website[]>([]);
  stripePayouts$: BehaviorSubject<StripePayout[]> = new BehaviorSubject<StripePayout[]>([]);
  twilioAccountBalance$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  messageBirdAccountBalance$: BehaviorSubject<SMSBalance> = new BehaviorSubject<SMSBalance>(new SMSBalance('', '', 0));
  whmcsStats$: BehaviorSubject<WhmcsStats> = new BehaviorSubject<WhmcsStats>(WhmcsStats.emptyWhmcsStats());

  monitorStatuses;

  constructor(
      private uptimeRobotService: UptimeRobotService,
      private whmcsService: WhmcsService,
      private  stripeService: StripeService,
      private wccService: WccService,
      private twilioService: TwilioService,
      private smsService: SmsService
  ) {
      this.monitorStatuses = UptimeRobotMonitorStatus;
  }

  ngOnInit(): void {
    this.getServerUptimeStatus();
    this.getWhmcsStats();
    this.getStripePayouts();
    this.getTwilioAccountBalance();
    this.getMessageBirdAccountBalance();
    this.getWebsitePromotions();
  }

  getStripePayouts(){
        this.loadingStripePayouts$.next(true);
        this.stripeService.getPendingPayouts()
            .subscribe((payouts: StripePayout[]) => {
                this.stripePayouts$.next(payouts);
                this.hasStripePayouts$.next(payouts.length > 0);
                this.loadingStripePayouts$.next(false);
            });
    }

  getServerUptimeStatus(){
    this.loadingMonitors$.next(true);
    this.uptimeRobotService.getMonitors()
        .subscribe((monitors: UptimeRobotMonitor[]) => {
          this.monitors$.next(monitors);
          this.hasMonitors$.next(monitors.length > 0);
          this.loadingMonitors$.next(false);
        });
  }

    getTwilioAccountBalance(){
        this.loadingTwilioAccountBalance$.next(true);
        this.twilioService.getTwilioAccountBalance()
            .subscribe((balance: string) => {
                this.twilioAccountBalance$.next(balance);
                this.loadingTwilioAccountBalance$.next(false);
            });
    }

    getMessageBirdAccountBalance(){
            this.loadingMessageBirdAccountBalance$.next(true);
            this.smsService.getSmsAccountBalance()
                .subscribe((balance: SMSBalance) => {
                    this.messageBirdAccountBalance$.next(balance);
                    this.loadingMessageBirdAccountBalance$.next(false);
                });
        }

    getWhmcsStats(){
        this.loadingWhmcsStats$.next(true);
        this.whmcsService.getWhmcsStats()
            .subscribe((stats: WhmcsStats) => {
                this.whmcsStats$.next(stats);
                this.loadingWhmcsStats$.next(false);
            });
    }

    getWebsitePromotions(){
        this.loadingWebsitePromotions$.next(true);
        this.wccService.getWebsites()
            .subscribe((websites: Website[]) => {
                this.websitePromotions$.next(websites);
                this.hasWebsitePromotions$.next(websites.length > 0);
                this.loadingWebsitePromotions$.next(false);
            });
    }

    getServerUptimeStatusText(status: UptimeRobotMonitorStatus): string {
      switch (status){
          case UptimeRobotMonitorStatus.UP:
              return 'UP';
          case UptimeRobotMonitorStatus.DOWN:
              return 'DOWN';
          case UptimeRobotMonitorStatus.SEEMS_DOWN:
              return 'SEEMS DOWN';
          case UptimeRobotMonitorStatus.PAUSED:
              return 'PAUSED';
          case UptimeRobotMonitorStatus.NOT_CHECKED_YET:
              return 'NOT CHECKED YET';
      }
    }

}
